"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "subtitle2StrongerClassNames", {
    enumerable: true,
    get: function() {
        return _useSubtitle2Strongerstyles.subtitle2StrongerClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Subtitle2Stronger"), exports);
const _useSubtitle2Strongerstyles = require("./useSubtitle2Stronger.styles");
